<template>
	<Row class="flex-align-center chips-container">
		<ChipOfContacts
			:hasClose="false"
			:item="suggestion"
			:key="suggestion.id"
			class="selection-chip mr-2"
			@click.native="() => selectItem(suggestion)"
			v-for="suggestion in allAvailableSuggestions"
		/>
		<h5 @click="$emit('open-combobox')" class="flex-align-center pointer more-button pl-4">More...</h5>
	</Row>
</template>
<script>
import ChipOfContacts from '@/components/dialogs/ShareModuleDialog/ChipOfContacts.vue';
export default {
	name: 'ShareDialogQuickSuggestions',
	props: {
		comboboxSelection: { type: Array },
		groupedTeamMembersToShareWith: { type: Array },
	},
	components: { ChipOfContacts },
	computed: {
		selectedItemsIds() {
			return this.comboboxSelection.map((item) => item.id);
		},
		allAvailableSuggestions() {
			return this.groupedTeamMembersToShareWith.filter(({ header }) => !header).filter((item) => !this.selectedItemsIds.includes(item.id));
		},
	},
	methods: {
		selectItem(item) {
			this.$emit('select-item', item.id);
		},
	},
};
</script>
<style scoped lang="scss">
::v-deep {
	.chip-container {
		margin: 0px;
		min-height: 30px;
	}
}
.selection-chip {
	cursor: pointer;
	border-radius: 8px;
	&:hover {
		cursor: pointer;
		transition: 0.1s;
		background: #bfbfc9;
		box-shadow: 0px 3px 6px var(--shadow-color);
	}
	&:active {
		transition: 0.1s;
		filter: brightness(0.9);
	}
}
.chips-container {
	max-width: 100%;
	overflow: hidden;
	width: fit-content;
	white-space: nowrap;
}
.more-button {
	right: 0px;
	z-index: 2;
	height: 30px;
	position: absolute;
	background: white;
	color: rgba(38, 38, 38, 0.5);
}
.chips-container[max-width~='579px'] {
	.more-button {
		display: none;
	}
}
.chips-container[min-width~='579px'] {
	.more-button {
		display: flex;
	}
}
</style>
